import img from '../../EN/data/Mainimg';
const ContData = [
	{
		'id': 1,
		'tit':'الفكره!',
		'p': <div className="des-p">
			<b>أولي خطوات العمل</b><br/>
                يتواصل العميل مع أحد موظفي خدمة العملاء الخاصين بنا و يوضح مشكلة ما تواجهه في عمله الخاص او مشروعه الناشئ و التي تسبب له نقص في أداء عمله الخاص <br/>
			<b>بعض من تلك المشاكل المحتمله:</b><br />
			<ol>
				<li>ضعف في المكسب و الدخل من العمل الخاص او المشروع الناشئ</li>
				<li>نقص في شريحة العملاء مما يترتب عليه ضعف في الدخل من المشروع</li>
				<li>ضعف عام في جميع اجزاء العمل او المشروع</li>
				<li>ضعف في حجم او جودة الإنتاج او ضعف في اي جانب من جوانب عملية الإنتاج
				</li>
			</ol>
		</div>,
		'img': img[0]
	},
	{
		'id': 2,
		'tit':'ثم -->',
		'p': <p className="des-p">
			<b>فريق شركة ساسك يتولي المهمه </b>
                نقوم ببعض عمليات البحث عن العمل الخاص بك او مشروعك الناشئ <br />
                وكل المشاكل التي تواجهك و ما أفضل حل مناسب لها
			<br />
                من خلال عمليات البحث السابقه نقوم بوضع خطه و إستراتيجيه تحدد اهدافنا الرئيسيه و الثانويه لحل هذه المشكله و العمل بكفائه اكبر و تحديد البرمجيه التي سنقوم بها
			<br />
                نقوم بكل هذه الخطوات السابقه من أجل أن نستطيع قياس مدي تأثير برمجياتنا المختاره لحل مشاكل العمل الخاص بك او مشروعك الناشئ
		</p>,
		'img': img[1]
	},
	{
		'id': 3,
		'tit':'المرحله الثانيه:',
		'p': <p className="des-p">
                في المرحله التاليه
			<br />
                سيقوم احد مهندسينا من فريق تصميم تجربة المستخدم بتصميم إطار مرئي جيد
			<br />
                في هذه الخطوه : هدفنا عمل تصميم سهل و بسيط لجعل رحلة المستخدم عند إستخدام برمجيتنا تكون سهله  جداً<br />
                و بنهاية هذه المرحله سنكون متأكدين بأن حلنا سوف يكون تجربه ممتعه  <br />
                و عملائك سيكونون سعداء بإستخدام برمجياتنا
		</p>,
		'img': img[2]
	},
	{
		'id': 4,
		'tit':'المرحله الثالثه:',
		'p':
		<p className="des-p">
			<b>في الخطوه الثالثه</b>
			<br />
			يتولي المهمه أحد مهندسينا من فريق تصميم واجهة المستخدم و يقوم بعمل تصميم ملون و جذاب نهائي 
			<br />
			لتطبيقنا معتمداً علي الإطار المرئي النهائي الذي تم تصميمه في الخطوه السابقه .
			<br /> 
			في هذه المرحله : هدفنا هو عمل تصميم جذاب و نتوقع كل ما يحتاجه عميلنا و التركيز عليه بإستخدام التسلسل الهرمي المرئي
			<br/>
			<b>لجذب أعين المستخدم علي الأجزاء الهامه بالتطبيق </b>
		</p>
		,
		'img': img[3]
	},
	{
		'id': 5,
		'tit':'المرحله الرابعه:',
		'p': <div className="des-p">
			<p>
				<b>في المرحله الرابعه: </b>
                        أحد مطورينا من فريق تطوير واجهة المستخدم سيتولي مهمة تكويد المشروع بواسطة إستخدام أفضل التقنيات التي تساعد المشروع ليكون اكثر جاذبيه و للحفاظ علي أفضل أداء مطورينا لديهم خبرات عاليه في كل التقنيات مثل: <br />
			</p>
			<ol className="row">
				<li className="col-md-6">html</li>
				<li className="col-md-6">react</li>
				<li className="col-md-6">javascript</li>
				<li className="col-md-6">pug js</li>
				<li className="col-md-6">sass</li>
				<li className="col-md-6">gulp</li>
				<li className="col-md-6">reactNative</li>
				<li className="col-md-6">WASM</li>
				<li className="col-md-6">electron</li>
				<li className="col-md-6">إلخ ...</li>
			</ol>
			<p>
                        نقدم أفضل جوده و أداء في هذه المرحله نكون قد أنتهينا من مراحل تصميم و تكويد واجهة المستخدم للتطبيق و في المرحله القادمه سنبدأ مراحل التحريك و عمليات الإختبارات و إعادة التكويد و تجهيز تقارير الأداء .
			</p>
		</div>,
		'img': img[4]
	},
	{
		'id': 6,
		'tit':'المرحله الخامسه:',
		'p': <div className="des-p">
			<b>في هذه الخطوه:</b>
			<br />
			<p>
                نقوم ببدء عملية التحريك و إضافة الروح في تطبيقنا نقوم بتمييز مشروعنا بإضافة الحياه له سوف نبدأ بإضافة الحركه في كل العناصر و في جميع أجزاء المشروع بواسطه بعض التقنيات مثل الأتي:
			</p>
			<ol>
				<li>green sock</li>
				<li>aos library</li>
				<li>animated library</li>
                        في بعض الحالات نقوم بإستخدام :<li>three library</li>
			</ol>
			<p>وأخيراً سيكون لدينا مشروع حي جذاب سهل و فريد من نوعه</p>
		</div>,
		'video': img[5]
	},
	{
		'id': 7,
		'tit':'المرحله السادسه:',
		'p': <div className="des-p">
			<p>
				<b>SEO</b>
				<br />
                        تحسين محركات البحث ليكون مشروعنا في اوائل نتائج البحث علي اشهر و أكبر محركات البحث بتوفير التالي
			</p>
			<ol>
				<li>كتابة كود نظيف وفق انماط التصميم المعروفه و المعترف بها</li>
				<li>صديق لمحركات البحث</li>
				<li>سهولة التصفح لذوي الحاجات الخاصه</li>
				<li>إستخدام كلمات مفتاحيه جيده & توفير الحمايه للتطبيق ككل</li>
			</ol>
		</div>,
		'img': img[6]
	},
	{
		'id': 8,
		'tit':'المرحله السابعه:',
		'p': <div className="des-p">
			<p>
				<b>في هذه المرحله:</b>
				<br />
                    نبدأ عملية الفحص و الإختبار للتأكد بأن كل شيئ يعمل كما هو مخطط له في جميع عناصر و أجزاء التطبيق من خلال أربع مستويات للإختبار:
			</p>
			<ol className="row">
				<li className="col-md-6">Unit Tests</li>
				<li className="col-md-6">Snapshots Tests</li>
				<li className="col-md-6">Integrations Tests</li>
				<li className="col-md-6">End to End Tests</li>
			</ol>
			<p>بإستخدام أحدث التقنيات مثل :</p>
			<ol className="row">
				<li className="col-md-6">Jest</li>
				<li className="col-md-6">mockup</li>
				<li className="col-md-6">assertion</li>
				<li className="col-md-6">Selenium</li>
			</ol>
			<p>
                        أخيراً سنقوم بإرسال نتيجة الإختبار كتقرير لتكون علي علم بكل شيئ يخص مرحلة الإختبار
			</p>
		</div>,
		'img': img[7]
	},
	{
		'id': 9,
		'tit':'المرحله الثامنه:',
		'p': <p className="des-p">
			<b>بعد مرحلة الإختبار</b>
			<br />
                    الأن أحد مطورين الواجهه الخلفيه لدي مشروعنا سيقوم بتجهيز بيئه العمل و قواعد البيانات التي تناسب التطبيق بأختيار وفق نمط تصميم معتمد و هيكليه بيانات تضمن الحصول علي البيانات بسرعه و سهوله
		</p>,
		'img': img[8]
	},
	{
		'id': 10,
		'tit':'المرحله التاسعه:',
		'p': <div className="des-p">
			<p>
				<b>مرحلة الواجهه الخلفيه:</b>
				<br />
                    نبدأ عملية تطوير الواجهه الخلفيه لتخزين بيانات المشروع في قواعد بياناتنا بطريقه ديناميكيه بواسطه بعض التقنيات مثل 
			</p>
			<ol>
				<li>Python</li>
				<li>Django</li>
				<li>PostgresSql</li>
				<li>mongodb</li>
			</ol>
		</div>,
		'img': img[9]
	},
	{
		'id': 11,
		'tit':'المرحله العاشره:',
		'p': <div className="des-p">
			<p>
				<b>عمليات أختبار الواجه الخلفيه:</b>
				<br />
                عملية إختبار الواجهه الخلفيه للتأكد من أن عملية جلب البيانات تتم بشكل صحيح بأفضل أداء ممكن بدون أي مشكلات في كل الاحتمالات بإستخدام بعض التقنيات مثل:
			</p>
			<ol>
				<li>Data factory</li>
				<li>Data Generator</li>
				<li>Turbodata</li>
			</ol>
		</div>,
		'img': img[10]
	},
	{
		'id': 12,
		'tit':'المرحله الحادية عشر:',
		'p': <p className="des-p">
			<b>المرحله الأخيره</b>
			<br />
                    رفع المشروع علي منصات الإستضافه او المتاجر ليصبح متاحاً لعملائك إستخدام المشروع (حجز شراء او بيع او أي خدمه أنت تقدمها في هذا التطبيق) بسهوله و بدون اي جهد مبذول من عملائك و الحفاظ على وقتهم
		</p>,
		'img': img[11]
	},
	{
		'id': 13,
		'tit':'أخيراً',
		'p': <div className="des-p">
			<p><b>تسطتيع</b></p>
			<ol>
				<li>
					<b>الخطه الذهبيه</b>: أشترك معنا لتحصل علي كل الدعم لهذا المشروع 
                        و لتطوير و تحسين التطبيق  كل ست شهور مقابل تكلفه منخفضه مقارنه بطلب تطبيق جديد
				</li>
				<li>
					<b>الخطه الفضيه</b>: أحصل علي الصيانه لمده 7 أيام ثم سوف تحصل علي عرض علي كل خدماتنا بخصم 50% لكل عملية صيانه في هذا المشروع 
				</li>
				<li>
					<b>الخطه البرونزيه</b>: أحصل علي صيانه لمدة 7 أيام وسوف تحصل علي نقاط مقابل كل عملية صيانه تقوم بها في هذا المشروع لشراء اي خدمه مقدمه من شركة ساسك بواسطه النقاط التي تمتلكها
				</li>
			</ol>
		</div>,
		'img': img[12]
	},

];

export default ContData;